import React from 'react';
import PageLayout from '../components/common/PageLayout';
import InventoryList from '../components/InventoryList';

const InventoryListPage = () => (
  <PageLayout
    title="Inventory List"
    showInventorySectionTabs
    showBreadcrumbs={false}
    navLinks={[
      { url: '/inventory/manage/', label: 'Manage Inventory' },
      { url: '/finance/rates/', label: 'Manage Rate' },
    ]}
  >
    <InventoryList />
  </PageLayout>
);

export default InventoryListPage;
